import update from '../utilities/update';
import { loading } from './shared/loading';
import { error } from './shared/error';
import {
      CREATE_MEMBER_START,
      CREATE_MEMBER_SUCCESS,
      CREATE_MEMBER_FAIL,
      GET_MEMBERS_START,
      GET_MEMBERS_SUCCESS,
      GET_MEMBERS_FAIL,
      SET_COMMISSION_TO_UPDATE,
      UPDATE_MEMBER_START,
      UPDATE_MEMBER_SUCCESS,
      UPDATE_MEMBER_FAIL,
      TOGGLE_BASIC_INFO_UPDATE,
      TOGGLE_BET_LIMIT_UPDATE,
      TOGGLE_COMMISSION_UPDATE,
      TOGGLE_SINGLE_BET_COMMISSION_UPDATE,
      TOGGLE_SINGLE_BET_UPDATE,
      TOGGLE_EXTRA_COMMISSION_UPDATE,
      TOGGLE_2D_COMMISSION_UPDATE,
      TOGGLE_3D_COMMISSION_UPDATE,
      TOGGLE_4D_COMMISSION_UPDATE,
      GET_ONE_MEMBER_START,
      GET_ONE_MEMBER_SUCCESS,
      GET_ONE_MEMBER_FAIL,
      UPDATE_SUSPEND_START,
      UPDATE_SUSPEND_SUCCESS,
      UPDATE_SUSPEND_FAIL,
      RESET_PASSWORD_START,
      RESET_PASSWORD_SUCCESS,
      RESET_PASSWORD_FAIL,
      TOGGLE_RESET_PASSWORD_MODAL,
      UPDATE_MEMBER_BALANCE
} from '../actions/member/actionTypes';

const initialState = {
      loading: false,
      error: null,
      message: null,
      all: [],
      one: {
            name: null,
            username: null,
            mobile: null,
            balance: 0,
            commissions: [],
            betLimitation: {
                  maxForSingleBet: 0,
                  maxForMixBet: 0,
            },
            singleBetCommission: {
                  betCommission: 0,
                  highBetCommission: 0,
                  winCommission: 0,
                  highWinCommission: 0
            },
            partnerShare: 0,
            extraCommissionAllowed: false,
            singleBetAllowed: false
      },
      commissionToUpdate: null,
      updateBasicInfoVisible: false,
      updateBetLimitVisible: false,
      updateCommissionVisible: false,
      updateSingleBetCommissionVisible: false,
      updateSingleBetVisible: false,
      updateExtraCommissionVisible: false,
      update2dCommissionVisible: false,
      update3dCommissionVisible: false,
      update4dCommissionVisible: false,
      resetPasswordVisible: false
}


const create = (state, action) => {
      return update(state, {
            loading: false,
            all: [...state.all, action.payload],
            message: 'create success'
      })
}

const updateMember = (state, action) => {
      console.log('update member', action.payload)
      return update(state, {
            loading: false,
            all: state.all
                  .map(
                        obj => obj.id === action.payload.id ? action.payload : obj
                  ),
            message: 'update success',
            one: action.payload
      })
}

const setCommissionToUpdate = (state, action) => {
      return update(state, {
            commissionToUpdate: action.payload
      })
}

const getMembers = (state, action) => {
      return update(state, {
            loading: false,
            all: action.payload
      })
}

const getMember = (state, action) => {
      return update(state, {
            loading: false,
            one: action.payload
      })
}

const updateSuspend = (state, action) => {
      return update(state, {
            loading: false,
            message: action.payload?.suspended ? 'suspended successfully' : 'unsuspended successfully',
            one: action.payload
      })
}

const resetPassword = (state, action) => {
      return update(state, {
            loading: false,
            message: 'Reset Password Successfully'
      })
}

const toggle4DCommissionUpdate=(state,action)=>{
      return update(state,{
            update4dCommissionVisible:!state.update4dCommissionVisible
      })
}

const updateMemberBalance = (state, action) => {
      let amount = 0;
      if (action.payload?.transactionType === "OUT") {
            amount = state.one?.balance + action.payload?.amount;
      } else {
            amount = state.one?.balance - action.payload?.amount;
      }
      return update(state, {
            one: {
                  ...state.one,
                  balance: amount
            }
      })
}

const memberReducer = (state = initialState, action) => {
      switch (action.type) {
            case CREATE_MEMBER_START:
                  return loading(state, action);
            case CREATE_MEMBER_SUCCESS:
                  return create(state, action);
            case CREATE_MEMBER_FAIL:
                  return error(state, action);
            case GET_MEMBERS_START:
                  return loading(state, action);
            case GET_MEMBERS_SUCCESS:
                  return getMembers(state, action);
            case GET_MEMBERS_FAIL:
                  return error(state, action);
            case UPDATE_MEMBER_START:
                  return loading(state, action);
            case UPDATE_MEMBER_SUCCESS:
                  return updateMember(state, action);
            case UPDATE_MEMBER_FAIL:
                  return error(state, action);
            case SET_COMMISSION_TO_UPDATE:
                  return setCommissionToUpdate(state, action);
            case TOGGLE_BASIC_INFO_UPDATE:
                  return update(state, {
                        updateBasicInfoVisible: !state.updateBasicInfoVisible
                  });
            case TOGGLE_BET_LIMIT_UPDATE:
                  return update(state, {
                        updateBetLimitVisible: !state.updateBetLimitVisible
                  });
            case TOGGLE_COMMISSION_UPDATE:
                  return update(state, {
                        updateCommissionVisible: !state.updateCommissionVisible
                  });
            case TOGGLE_SINGLE_BET_COMMISSION_UPDATE:
                  return update(state, {
                        updateSingleBetCommissionVisible: !state.updateSingleBetCommissionVisible
                  });
            case TOGGLE_SINGLE_BET_UPDATE:
                  return update(state, {
                        updateSingleBetVisible: !state.updateSingleBetVisible
                  });
            case TOGGLE_EXTRA_COMMISSION_UPDATE:
                  return update(state, {
                        updateExtraCommissionVisible: !state.updateExtraCommissionVisible
                  });
            case TOGGLE_2D_COMMISSION_UPDATE:
                  return update(state, {
                        update2dCommissionVisible: !state.update2dCommissionVisible
                  });
            case TOGGLE_3D_COMMISSION_UPDATE:
                  return update(state, {
                        update3dCommissionVisible: !state.update3dCommissionVisible
                  });
            case TOGGLE_4D_COMMISSION_UPDATE:
                  return toggle4DCommissionUpdate(state,action);
            case GET_ONE_MEMBER_START:
                  return loading(state, action);
            case GET_ONE_MEMBER_SUCCESS:
                  return getMember(state, action);
            case GET_ONE_MEMBER_FAIL:
                  return error(state, action);
            case UPDATE_SUSPEND_START:
                  return loading(state, action);
            case UPDATE_SUSPEND_SUCCESS:
                  return updateSuspend(state, action);
            case UPDATE_SUSPEND_FAIL:
                  return error(state, action);
            case RESET_PASSWORD_START:
                  return loading(state, action);
            case RESET_PASSWORD_SUCCESS:
                  return resetPassword(state, action);
            case RESET_PASSWORD_FAIL:
                  return error(state, action);
            case TOGGLE_RESET_PASSWORD_MODAL:
                  return update(state, {
                        resetPasswordVisible: !state.resetPasswordVisible
                  });
            case UPDATE_MEMBER_BALANCE:
                  return updateMemberBalance(state, action);
            default:
                  return state;
      }
}

export default memberReducer;